import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {FormGroup,FormControl,Validators} from '@angular/forms';
import {AuthService} from '../../core/auth/auth.service';
import { UserService } from '../../core/user.service';
import swal from 'sweetalert2';
@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

    hostUrl;
    registerForm:FormGroup = new FormGroup({
        email:new FormControl(null,[Validators.email,Validators.required]),
        username:new FormControl(null,Validators.required),
        password:new FormControl(null,Validators.required),
        cpass:new FormControl(null,Validators.required)
    });
    constructor(private _router:Router, private _userService:AuthService, private userService: UserService) { }

    ngOnInit() {
        this.hostUrl=this.userService.getUrl();
    }

    moveToLogin(){
        this._router.navigate(['/login']);
    }

    register(){
        if(!this.registerForm.valid || (this.registerForm.controls.password.value != this.registerForm.controls.cpass.value)){
        }

        this._userService.register(JSON.stringify(this.registerForm.value))
            .subscribe(
                data=> {                
                    if(JSON.stringify(data["errormsg"]))
                    {
                    swal({
                            type:'error',
                            width: 300,
                            text:'Email Already Taken',
                            showConfirmButton: false,                   
                            timer: 1500
                      })
                    }
                    else if(JSON.stringify(data["successmsg"]))
                    {
                        swal({
                            type:'success',
                            width: 300,
                            text:'Successfully Registered',
                            showConfirmButton: false,                   
                            timer: 1500
                      })
                      this._router.navigate(['/login']);
                    }                

                }
            )
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/register/register.component.ts